import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export const convertBase64ToPDF = async (
  base64Pdf,
  fileName = 'meest-saved-file',
) => {
  try {
    var pdfData = `data:application/pdf;base64,${base64Pdf}`;

    saveAs(pdfData, fileName);
  } catch (error) {
    console.error('Error while saving PDF file:', error);
  }
};

export const convertBase64ToImage = async (
  base64Image,
  fileName = 'meest-saved-image.jpg',
) => {
  try {
    // Extract the file extension from the fileName
    const extension = fileName.split('.').pop().toLowerCase();

    // Determine the MIME type based on the extension
    let mimeType;
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        mimeType = 'image/jpeg';
        break;
      case 'png':
        mimeType = 'image/png';
        break;
      case 'gif':
        mimeType = 'image/gif';
        break;
      default:
        throw new Error(`Unsupported file extension: ${extension}`);
    }

    // Prepare the data URI
    const imageData = `data:${mimeType};base64,${base64Image}`;

    // Save the file
    saveAs(imageData, fileName);
  } catch (error) {
    console.error('Error while saving image file:', error);
  }
};

export const exportToExcel = (data, fileName = 'meest-saved-file') => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
